import { appName } from './brand';
// ─── Share Card Generator (Canvas API) ───
// roundRect polyfill for iOS < 16.1
if(typeof CanvasRenderingContext2D!=="undefined"&&!CanvasRenderingContext2D.prototype.roundRect){
  CanvasRenderingContext2D.prototype.roundRect=function(x,y,w,h,r){
    r=Math.min(r||0,w/2,h/2);this.moveTo(x+r,y);this.lineTo(x+w-r,y);this.arcTo(x+w,y,x+w,y+r,r);
    this.lineTo(x+w,y+h-r);this.arcTo(x+w,y+h,x+w-r,y+h,r);this.lineTo(x+r,y+h);
    this.arcTo(x,y+h,x,y+h-r,r);this.lineTo(x,y+r);this.arcTo(x,y,x+r,y,r);this.closePath();
  };
}

// Safe stringification — guards against null/undefined inside stat values
const _safeStr=(v)=>v===null||v===undefined?"—":String(v);

export const ShareCard={
  generate:async(title,stats,subtitle)=>{
    const W=600,H=400;
    const dpr=Math.max(1,Math.min(3,(typeof window!=="undefined" && window.devicePixelRatio)||1));
    const c=document.createElement("canvas");
    c.width=W*dpr; c.height=H*dpr;
    c.style.width=W+"px"; c.style.height=H+"px";
    const ctx=c.getContext("2d");
    ctx.scale(dpr,dpr);
    // Background
    const bg=ctx.createLinearGradient(0,0,W,H);bg.addColorStop(0,"#0e0e16");bg.addColorStop(1,"#1a1a2e");
    ctx.fillStyle=bg;ctx.beginPath();ctx.roundRect(0,0,W,H,24);ctx.fill();
    // Border
    ctx.strokeStyle="rgba(34,197,94,0.3)";ctx.lineWidth=2;ctx.beginPath();ctx.roundRect(1,1,W-2,H-2,24);ctx.stroke();
    // App brand (org app name when white-labelled)
    ctx.font="bold 14px Inter,system-ui,sans-serif";ctx.fillStyle="rgba(255,255,255,0.4)";ctx.fillText(appName(),24,36);
    // Title
    ctx.font="bold 28px Inter,system-ui,sans-serif";ctx.fillStyle="#e4e4e7";ctx.fillText(_safeStr(title),24,90);
    // Subtitle
    if(subtitle){ctx.font="14px Inter,system-ui,sans-serif";ctx.fillStyle="#71717a";ctx.fillText(_safeStr(subtitle),24,115);}
    // Stats grid
    const list=Array.isArray(stats)?stats:[];
    const cols=Math.max(1,Math.min(list.length,3));
    const boxW=Math.floor((W-48-16*(cols-1))/cols);
    list.forEach((s,i)=>{
      if(!s)return;
      const col=i%cols;const row=Math.floor(i/cols);
      const x=24+col*(boxW+16);const y=140+row*100;
      ctx.fillStyle="rgba(255,255,255,0.03)";ctx.beginPath();ctx.roundRect(x,y,boxW,80,12);ctx.fill();
      ctx.strokeStyle="rgba(255,255,255,0.06)";ctx.lineWidth=1;ctx.beginPath();ctx.roundRect(x,y,boxW,80,12);ctx.stroke();
      ctx.font="bold 32px 'SF Mono',monospace";ctx.fillStyle=s.color||"#22c55e";ctx.fillText(_safeStr(s.value),x+16,y+42);
      ctx.font="bold 10px Inter,system-ui,sans-serif";ctx.fillStyle="#71717a";ctx.fillText(_safeStr(s.label).toUpperCase(),x+16,y+62);
    });
    // Date
    ctx.font="12px Inter,system-ui,sans-serif";ctx.fillStyle="#71717a";
    ctx.fillText(new Date().toLocaleDateString(undefined,{month:"long",day:"numeric",year:"numeric"}),24,380);
    return c;
  },
  share:async(canvas,filename)=>{
    return new Promise((resolve)=>{
      if(!canvas||!canvas.toBlob){ShareCard.download(canvas,filename);resolve({ok:false,reason:"no-canvas"});return;}
      canvas.toBlob(async blob=>{
        if(!blob){ShareCard.download(canvas,filename);resolve({ok:true,fallback:"download"});return;}
        if(navigator.share && navigator.canShare && navigator.canShare({files:[new File([blob],filename||"ironlog-share.png",{type:"image/png"})]})){
          try{
            await navigator.share({files:[new File([blob],filename||"ironlog-share.png",{type:"image/png"})],title:appName()});
            resolve({ok:true,via:"share"});
          }catch(e){
            // User cancelled — don't fall through to download
            if(e && e.name==="AbortError"){resolve({ok:false,cancelled:true});return;}
            ShareCard.download(canvas,filename);
            resolve({ok:true,fallback:"download",err:String(e&&e.message||e)});
          }
        }else{
          ShareCard.download(canvas,filename);
          resolve({ok:true,fallback:"download"});
        }
      },"image/png");
    });
  },
  download:(canvas,filename)=>{
    if(!canvas)return;
    // Prefer Blob + Object URL to avoid the 5 MB toDataURL ceiling on Safari
    if(canvas.toBlob){
      canvas.toBlob(blob=>{
        if(!blob){ // fall back to data URL
          try{const url=canvas.toDataURL("image/png");const a=document.createElement("a");a.href=url;a.download=filename||"ironlog-share.png";a.click();}catch{}
          return;
        }
        const url=URL.createObjectURL(blob);
        const a=document.createElement("a");a.href=url;a.download=filename||"ironlog-share.png";a.click();
        setTimeout(()=>URL.revokeObjectURL(url),1000);
      },"image/png");
    }else{
      try{const url=canvas.toDataURL("image/png");const a=document.createElement("a");a.href=url;a.download=filename||"ironlog-share.png";a.click();}catch{}
    }
  },
};
